"use client";

import { useContext } from "react";
import { DashboardThemeContext } from "@/components/dashboard/DashboardThemeProvider";

const CLASSIC = {
  card: "0",
  control: "0",
  badge: "2px",
} as const;

const MODERN = {
  card: "12px",
  control: "8px",
  badge: undefined,
} as const;

function readClassicFromDom(): boolean {
  if (typeof document === "undefined") return false;
  return (
    document.documentElement.getAttribute("data-dashboard-appearance") ===
      "classic" ||
    document.body.getAttribute("data-dashboard-appearance") === "classic"
  );
}

/** Shared radius / blur helpers for dashboard layout primitives. */
export function useClassicDashboardStyles() {
  const context = useContext(DashboardThemeContext);
  const isClassicDashboardActive =
    context?.isClassicDashboardActive ?? readClassicFromDom();
  const radii = isClassicDashboardActive ? CLASSIC : MODERN;

  return {
    isClassic: isClassicDashboardActive,
    cardBorderRadius: radii.card,
    controlBorderRadius: radii.control,
    badgeBorderRadius: radii.badge,
    backdropBlur: isClassicDashboardActive ? "none" : undefined,
  };
}
